import { Box, ImageList, ImageListItem, Link, Typography } from "@mui/material";
import React from "react";
import AppButton from "../../components/app-button/AppButton";
import AppDialog from "../../components/app-dialog/AppDialog";
import Iconify from "../../components/iconify/Iconify";
import ItemImagesView from "./ItemImagesView";
import ItemVariantImageSelectionIcon from "./ItemVariantImageSelectionIcon";

const ItemVariantImageUploadDialog = ({
  selectImageDialogOpen,
  selectImageCloseDialog,
  handleFileClick,
  files = [],
  uploadedFiles = [],
  selectedVariantImages = [],
  uploadedVariantImages = [],
  chooseImage,
  chooseUploadedImage,
  selectItemImageClick,
  IMAGE_URL,
  IMAGE_TEMP_URL,
  storeId,
}) => {
  return (
    <AppDialog
      maxWidth="md"
      fullWidth
      handleClickClose={selectImageCloseDialog}
      isOpen={selectImageDialogOpen}
      id="select_image_dialog"
      title={<>{"Choose Variant Images"}</>}
    >
      <Box className="choose-image-dialog" sx={{ p: 2 }}>
        <Box>
          <Box sx={{ mb: 4 }}>
            <input
              //   onChange={(event) => handleFileChange(event)}
              accept="image/*"
              type="file"
              //   ref={inputFile}
              style={{ display: "none" }}
            />

            <Box>
              <Box sx={{ mb: 2 }}>
                <Box
                  sx={{
                    width: 135,
                    height: 135,
                    m: "auto",
                    display: "flex",
                    cursor: "pointer",
                    overflow: "hidden",
                    borderRadius: "15%",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    border: "1px dashed rgba(145, 158, 171, 0.32)",
                  }}
                >
                  {!false && (
                    <Link
                      //   onClick={handleFileClick}
                      style={{ textDecoration: "none" }}
                    >
                      <Box
                        sx={{
                          width: 110,
                          height: 110,
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          color: "rgb(145, 158, 171)",
                          bgcolor: "rgb(244, 246, 248)",
                          transition:
                            "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                          borderRadius: "15%",
                        }}
                      >
                        <Iconify sx={{ width: 40 }} icon="mdi:camera-plus" />
                        <Typography sx={{ fontSize: 14 }}>
                          Upload image
                        </Typography>
                      </Box>
                    </Link>
                  )}
                </Box>

                <Typography
                  sx={{
                    mt: 2,
                    lineHeight: 1.5,
                    fontSize: "0.75rem",
                    fontWeight: 400,
                    color: "rgb(99, 115, 129)",
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  Allowed *.jpeg, *.jpg, *.png max size of 1 MB
                </Typography>
              </Box>
            </Box>
          </Box>
          <ItemImagesView />
        </Box>

        {/* Uploaded Media Section */}
        <Box>
          <Typography
            className="select-images-text"
            sx={{ mt: 3, mb: 1, fontWeight: 500 }}
          >
            Uploaded Media
          </Typography>

          {/* Item-level existing images */}
          <ImageList cols={5} gap={12} sx={{ mb: 3 }}>
            {files?.map((file) => (
              <ImageListItem
                key={file?.uid}
                onClick={(event) => chooseImage(event, file)}
                sx={{
                  position: "relative",
                  cursor: "pointer",
                  "& img": {
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    width: "100%",
                    height: 80,
                    objectFit: "cover",
                  },
                }}
              >
                <img
                  src={`${IMAGE_URL}?type=items&id=${storeId}&img_id=${file.image}`}
                  alt="Variant"
                  loading="lazy"
                />
                <ItemVariantImageSelectionIcon
                  file={file}
                  selectedVariantImages={selectedVariantImages}
                />
              </ImageListItem>
            ))}
          </ImageList>

          {/* Newly uploaded (temporary) images */}
          {uploadedFiles?.length > 0 && (
            <>
              <Typography
                className="select-images-text"
                sx={{ mt: 2, mb: 1, fontWeight: 500 }}
              >
                Recently Uploaded
              </Typography>

              <ImageList cols={5} gap={12}>
                {uploadedFiles.map((file) => (
                  <ImageListItem
                    key={file?.uid}
                    onClick={(event) => chooseUploadedImage(event, file)}
                    sx={{
                      position: "relative",
                      cursor: "pointer",
                      "& img": {
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                        width: "100%",
                        height: 80,
                        objectFit: "cover",
                      },
                    }}
                  >
                    <img
                      src={`${IMAGE_TEMP_URL}/tempImage/path?img_id=${file?.filename}`}
                      alt="Uploaded"
                      loading="lazy"
                    />
                    <ItemVariantImageSelectionIcon
                      file={file}
                      uploadedVariantImages={uploadedVariantImages}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </>
          )}
        </Box>

        {/* Footer Buttons */}
        <Box
          className="variant-btn-wrap"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 3,
            gap: 2,
          }}
        >
          <AppButton
            variant="outlined"
            onClick={selectImageCloseDialog}
            color="inherit"
          >
            Cancel
          </AppButton>
          <AppButton variant="contained" onClick={selectItemImageClick}>
            Select
          </AppButton>
        </Box>
      </Box>
    </AppDialog>
  );
};

export default ItemVariantImageUploadDialog;
